import { BaseCellProps } from "@components/spreadsheet/cells";
import { ColumnDef } from "@components/spreadsheet/types";
import { LABEL_FIELD } from "./reportTaskFields";

export const LABEL_COLUMN: ColumnDef = {
    field: LABEL_FIELD,
    label: "Category",
    isEditable: false,
    width: 280,
    pinned: "left",
    cellFn: ({ value }: BaseCellProps) => <span>{String(value ?? "")}</span>,
};
